import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { forMobile, hoverable, theme } from '@/design-system';

const CONTENT_MAX_WIDTH = 1864;
const HEADER_HEIGHT = 56;
const LOGO_HEIGHT = 28;

export const LayoutRoot = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  minHeight: '100vh',
  background: theme.colors.background.canvas,
});

export const Header = styled('header')({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  borderBottom: `1px solid ${theme.colors.border.subtle}`,
});

export const HeaderInner = styled('div')({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  maxWidth: CONTENT_MAX_WIDTH,
  height: HEADER_HEIGHT,
  boxSizing: 'border-box',
  padding: `0 ${theme.spacing[24]}px`,

  [forMobile]: {
    padding: `0 ${theme.spacing[16]}px`,
  },
});

export const HeaderLogoLink = styled(Link)({
  ...hoverable(theme, 'lift'),
  display: 'inline-flex',
  alignItems: 'center',
  height: LOGO_HEIGHT,
  color: 'inherit',
  textDecoration: 'none',
  borderRadius: theme.radius[8],

  '&:focus-visible': {
    outline: `2px solid ${theme.colors.border.focus}`,
    outlineOffset: 2,
  },
});

export const HeaderLogo = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  height: LOGO_HEIGHT,

  '& [data-logo="desktop"]': {
    display: 'block',
    width: 110,
    height: LOGO_HEIGHT,
  },

  '& [data-logo="mobile"]': {
    display: 'none',
    width: 25,
    height: LOGO_HEIGHT,
  },

  [forMobile]: {
    '& [data-logo="desktop"]': {
      display: 'none',
    },

    '& [data-logo="mobile"]': {
      display: 'block',
    },
  },
});

export const Main = styled('main')({
  flexGrow: 1,
  width: '100%',
  maxWidth: CONTENT_MAX_WIDTH,
  boxSizing: 'border-box',
  padding: `${theme.spacing[24]}px ${theme.spacing[24]}px ${theme.spacing[48]}px`,

  [forMobile]: {
    padding: `${theme.spacing[16]}px ${theme.spacing[16]}px ${theme.spacing[32]}px`,
  },
});
